export const SHOW_POPUP_ACITON = 'SHOW_POPUP_ACITON' as const;

export const HIDE_POPUP_ACTION = 'HIDE_POPUP_ACTION' as const;
